export default "__VITE_ASSET__BmwSBNVG__"